import { DropdownMenuContent, DropdownMenuRadioGroup, DropdownMenuRadioItem } from "@hulahoop/ui";
import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

export interface SiblingRecordItem {
  value: string;
  href: string;
  label: string;
  media?: ReactNode;
  trailing?: string;
}

export function SiblingRecordMenu({
  items,
  current,
}: {
  items: readonly SiblingRecordItem[];
  current: string;
}) {
  const navigate = useNavigate();
  return (
    <DropdownMenuContent align="start" className="min-w-64">
      <DropdownMenuRadioGroup
        value={current}
        onValueChange={(value) => {
          const item = items.find((candidate) => candidate.value === value);
          if (item && value !== current) void navigate(item.href);
        }}
      >
        {items.map((item) => (
          <DropdownMenuRadioItem key={item.value} value={item.value}>
            {item.media}
            <span className="min-w-0 flex-1 truncate">{item.label}</span>
            {item.trailing && (
              <span className="shrink-0 text-(length:--font-caption) tabular-nums text-muted-foreground">
                {item.trailing}
              </span>
            )}
          </DropdownMenuRadioItem>
        ))}
      </DropdownMenuRadioGroup>
    </DropdownMenuContent>
  );
}
